"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const Heading6 = (props) => React.createElement("svg", { className: "lucide lucide-heading-6", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M4 12h8M4 18V6M12 18V6" }),
    React.createElement("circle", { cx: "19", cy: "16", r: "2" }),
    React.createElement("path", { d: "M20 10c-2 2-3 3.5-3 6" }));
exports.default = Heading6;
